import { useState } from 'react';
import Icon from './Icon';
import { iosBrowser, isIOS, isStandalone, useInstallPrompt } from '../lib/homeScreen';
import { useApp } from '../lib/AppContext';

// A website can't put its own icon on an iPhone's home screen, so this walks the user through
// Safari's "Add to Home Screen". Where the browser allows it (Android, desktop Chrome) it installs directly.
export default function HomeScreenCard() {
  const { editable } = useApp();
  const { available, install } = useInstallPrompt();
  const [installed, setInstalled] = useState(isStandalone);
  const opens = editable ? 'nhật ký của bạn' : 'nhật ký này';

  return (
    <section className="card rounded-[20px] bg-base-100">
      <div className="card-body gap-3 p-4">
        <h2 className="card-title text-base">Thêm vào màn hình chính</h2>

        {installed && (
          <p className="flex items-center gap-1.5 text-sm text-success"><Icon name="check" className="size-4" /> Macro Mate đã có trên màn hình chính của bạn.</p>
        )}

        {!installed && (
          <p className="text-sm text-muted">
            Có biểu tượng Macro Mate trên điện thoại, chạm vào là mở thẳng {opens}, toàn màn hình như một ứng dụng.
          </p>
        )}

        {!installed && available && (
          <button type="button" className="btn btn-primary" onClick={async () => setInstalled(await install())}>
            <Icon name="plus" className="size-4" /> Thêm vào màn hình chính
          </button>
        )}

        {!installed && !available && isIOS && (
          <ol className="list-decimal space-y-2 pl-5 text-sm">
            {iosBrowser === 'Safari' ? (
              <li>
                Nhấn nút <b>Chia sẻ</b> <Icon name="share" className="inline size-4 align-text-bottom" /> ở thanh dưới
                của Safari (trên iOS mới, nút này nằm trong nút <b>•••</b>).
              </li>
            ) : (
              <li>
                Nhấn nút <b>Chia sẻ</b> <Icon name="share" className="inline size-4 align-text-bottom" /> trên thanh địa
                chỉ của {iosBrowser}. Nếu không thấy, hãy mở trang này bằng <b>Safari</b>.
              </li>
            )}
            <li>Kéo xuống và chọn <b>Thêm vào MH chính</b> (Add to Home Screen).</li>
            <li>Nhấn <b>Thêm</b> ở góc trên bên phải.</li>
          </ol>
        )}

        {!installed && !available && !isIOS && (
          <p className="text-sm">
            Mở menu của trình duyệt và chọn <b>Thêm vào màn hình chính</b> hoặc <b>Cài đặt ứng dụng</b>.
            Trên iPhone, mở trang này bằng Safari để xem hướng dẫn.
          </p>
        )}

        {!installed && editable && (
          <p className="text-xs text-muted">
            Lần đầu mở từ biểu tượng, iPhone có thể yêu cầu đăng nhập lại một lần.
          </p>
        )}
      </div>
    </section>
  );
}
